export const sliderGalleryV1 = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-v1 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    cssMode: true,
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 30,
    speed: 800,
    threshold: 10,
    centeredSlides: false,
    // longSwipesRatio: 2,
    resistance: false,

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.closest(".slider-gallery").querySelector(".swiper-button-next"),
      prevEl:el.closest(".slider-gallery").querySelector(".swiper-button-prev"),
    },
    // breakpoints: {
    //   1023: {
    //     slidesPerView: 1,
    //     spaceBetween: 0,
    //   },
    //   640: {
    //     slidesPerView: 1,
    //     spaceBetween: 0,
    //   },
    // },
  }),
};
